<ul id="detail_wbinfo_marg" class="p-0">
  @if (termin.angebot?.bildungsart; as bildungsart) {
    <li class="d-flex flex-column mb-2">
      <span id="_marg_wbinfo_bildungsart_label" class="fw-bold">Bildungsart</span>
      <span id="_marg_wbinfo_bildungsart">
        {{ bildungsart.bezeichnung }}
      </span>
    </li>
  }

  @if (termin.unterrichtszeit; as unterrichtszeit) {
    <li class="d-flex flex-column mb-2">
      <span id="_marg_wbinfo_uzeit_label" class="fw-bold">Unterrichtszeit</span>
      <span id="_marg_wbinfo_uzeit" class="simple-chip-wrapper">
        <now-wbsuche-lib-chip
          [icon]="getIconByUnterrichtszeitId(unterrichtszeit.id)"
          [single]="true"
          >{{ unterrichtszeit.bezeichnung }}</now-wbsuche-lib-chip
        >
      </span>
    </li>
  }

  @if (termin.berufsbegleitend) {
    <li class="d-flex flex-column mb-2">
      <span id="_marg_wbinfo_berufsbegleitend_label" class="fw-bold">Berufsbegleitend</span>
      <span id="_marg_wbinfo_berufsbegleitend"> Ja </span>
    </li>
  }

  @if (termin.unterrichtsform) {
    <li class="d-flex flex-column mb-2">
      <span id="_marg_wbinfo_uform_label" class="fw-bold">Lernform</span>
      <span id="_marg_wbinfo_uform" class="simple-chip-wrapper">
        <now-wbsuche-lib-chip
          [icon]="getIconByUnterrichtsformId(termin.unterrichtsform.id)"
          [single]="true"
          >{{ getLernform() }}</now-wbsuche-lib-chip
        >
      </span>
    </li>
  }

  @if (termin.praxisanteile) {
    <li class="d-flex flex-column mb-2">
      <span class="fw-bold" id="_marg_wbinfo_praxisanteile_label"
        >Praxisanteile beim Arbeitgeber</span
      >
      <span id="_marg_wbinfo_praxisanteile"> Ja </span>
    </li>
  }

  @if (termin?.inhouseFirmenseminar; as inhouseFirmenseminar) {
    <li class="d-flex flex-column mb-2">
      <span class="fw-bold" id="_marg_wbinfo_inhousefirmenseminar_label"
        >Inhouse / Firmenseminar</span
      >
      <span id="_marg_wbinfo_inhousefirmenseminar"> Ja </span>
    </li>
  }

  @if (termin.angebot?.abschlussart; as abschlussart) {
    <li class="d-flex flex-column mb-2">
      <span class="fw-bold" id="_marg_wbinfo_abschlussart_label">Abschlussart</span>
      <span
        class="keywords"
        [innerHTML]="sanitizeFunction(abschlussart)"
        id="_marg_wbinfo_abschlussart"
      ></span>
    </li>
  }

  @if (termin.angebot?.abschlussbezeichnung; as abschlussbezeichnung) {
    <li class="d-flex flex-column mb-2">
      <span id="_marg_wbinfo_abschlussbez_label" class="fw-bold">Abschlussbezeichnung</span>
      <span
        class="keywords"
        id="_marg_wbinfo_abschlussbez"
        [innerHTML]="sanitizeAndBreakTitle(termin.angebot.abschlussbezeichnung!)"
      >
      </span>
    </li>
  }

  @if (termin.angebot?.berechtigungen; as berechtigungen) {
    <li class="d-flex flex-column mb-2">
      <span id="_marg_wbinfo_berechtigungen_label" class="fw-bold">Berechtigungen</span>
      <span
        id="_marg_wbinfo_berechtigungen"
        class="keywords"
        [innerHTML]="sanitizeAndBreakTitle(berechtigungen)"
      >
      </span>
    </li>
  }

  @if (termin.angebot?.zusatzqualifikationen; as zusatzqualifikationen) {
    <li class="d-flex flex-column mb-2">
      <span id="_marg_wbinfo_zusatzquali_label" class="fw-bold">Zusatzqualifikationen</span>
      <span
        id="_marg_wbinfo_zusatzquali"
        class="keywords"
        [innerHTML]="sanitizeAndBreakTitle(zusatzqualifikationen)"
      >
      </span>
    </li>
  }

  @if (termin.pruefendeStelle; as pruefendeste) {
    <li class="d-flex flex-column mb-2">
      <span id="_marg_wbinfo_pruefendeste_label" class="fw-bold">Prüfende Stelle</span>
      <span id="_marg_wbinfo_pruefendeste">{{ pruefendeste }} </span>
    </li>
  }

  @if (termin.angebot?.schulart; as schulart) {
    <li class="d-flex flex-column mb-2">
      <span id="_marg_wbinfo_schulart_label" class="fw-bold">Schulart</span>
      <span id="_marg_wbinfo_schulart">{{ schulart.bezeichnung }} </span>
    </li>
  }
  @if (getBarriereFreiheit(); as barriereFreiheit) {
    <li class="d-flex flex-column mb-2">
      <span id="_marg_wbinfo_barrierefrei_label" class="fw-bold">Barrierefreier Ort</span>
      <span id="_marg_wbinfo_barrierefrei">{{ barriereFreiheit }} </span>
    </li>
  }

  @if (termin.angebot?.traeger; as traeger) {
    <li class="d-flex flex-column">
      <span id="_marg_wbinfo_rehatraeger_label" class="fw-bold">Reha-Träger</span>
      <span id="_marg_wbinfo_rehatraeger">{{ traeger.bezeichnung }} </span>
    </li>
  }
</ul>
